import { Link, Outlet } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Logo } from "@/components/atoms/Logo";
import { LanguageSwitcher } from "@/components/molecules/LanguageSwitcher";
import { ThemeToggle } from "@/components/molecules/ThemeToggle";
import { ROUTES } from "@/app/router/routes";

/** Shell for pages used without signing in (guest booking): brand, language, theme, sign-in. */
export function PublicLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-dvh bg-background">
      <header className="glass sticky top-0 z-20 border-b">
        <div className="mx-auto flex h-16 w-full max-w-6xl items-center gap-3 px-4 sm:px-6">
          <Link to={ROUTES.BOOK} className="flex min-w-0 items-center gap-3" aria-label="Cure+ Clinics">
            <Logo compact />
            <span className="truncate text-base font-bold tracking-tight sm:text-lg">Cure+ Clinics</span>
          </Link>
          <div className="ml-auto flex items-center gap-2 sm:gap-3">
            <LanguageSwitcher />
            <ThemeToggle className="hidden sm:inline-flex" />
            <Link to={ROUTES.LOGIN} className="inline-flex items-center gap-1.5 rounded-xl px-3 py-2 text-sm font-semibold text-primary hover:bg-primary-soft">
              <LogIn className="h-4 w-4" aria-hidden />
              <span className="hidden sm:inline">{t("publicBooking.signIn")}</span>
            </Link>
          </div>
        </div>
      </header>
      <main id="main" tabIndex={-1} className="mx-auto w-full max-w-6xl px-4 py-6 focus:outline-none sm:px-6 sm:py-8">
        <Outlet />
      </main>
    </div>
  );
}
